// Header dropdown on hover with smooth open/close animation
document.addEventListener('DOMContentLoaded', function () {
  const desktopBreakpoint = window.matchMedia('(min-width: 990px)');

  const headerMenus = document.querySelectorAll(
    '.header__inline-menu header-menu > details'
  );

  const animationDuration = 280;

  headerMenus.forEach(function (details) {
    const summary = details.querySelector(':scope > summary');
    const submenu = details.querySelector(':scope > .header__submenu');

    let closeTimer;
    let animationTimer;

    function updateAriaExpanded(value) {
      if (summary) {
        summary.setAttribute('aria-expanded', value);
      }
    }

    function finishClose(menu) {
      window.clearTimeout(menu._animationTimer);

      menu.classList.remove('is-open', 'is-closing');
      menu.removeAttribute('open');

      const menuSummary = menu.querySelector(':scope > summary');

      if (menuSummary) {
        menuSummary.setAttribute('aria-expanded', 'false');
      }
    }

    function closeOtherMenus(currentMenu) {
      headerMenus.forEach(function (menu) {
        if (
          menu !== currentMenu &&
          (menu.hasAttribute('open') || menu.classList.contains('is-open'))
        ) {
          menu.classList.remove('is-open');
          menu.classList.add('is-closing');

          const menuSummary = menu.querySelector(':scope > summary');

          if (menuSummary) {
            menuSummary.setAttribute('aria-expanded', 'false');
          }

          window.clearTimeout(menu._animationTimer);

          menu._animationTimer = window.setTimeout(function () {
            finishClose(menu);
          }, animationDuration);
        }
      });
    }

    function openMenu() {
      if (!desktopBreakpoint.matches) return;

      window.clearTimeout(closeTimer);
      window.clearTimeout(animationTimer);
      window.clearTimeout(details._animationTimer);

      closeOtherMenus(details);

      details.classList.remove('is-closing');

      /*
       * Pehle details open hota hai taake submenu render ho.
       * Uske baad next frame mein animation start hoti hai.
       */
      details.setAttribute('open', '');
      updateAriaExpanded('true');

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          details.classList.add('is-open');
        });
      });
    }

    function closeMenu() {
      if (!desktopBreakpoint.matches) return;

      window.clearTimeout(closeTimer);
      window.clearTimeout(animationTimer);

      closeTimer = window.setTimeout(function () {
        details.classList.remove('is-open');
        details.classList.add('is-closing');

        updateAriaExpanded('false');

        /*
         * Closing transition complete hone ke baad
         * details ka open attribute remove hoga.
         */
        animationTimer = window.setTimeout(function () {
          details.classList.remove('is-closing');
          details.removeAttribute('open');
        }, animationDuration);
      }, 120);
    }

    details.addEventListener('mouseenter', openMenu);
    details.addEventListener('mouseleave', closeMenu);

    details.addEventListener('focusin', openMenu);

    details.addEventListener('focusout', function (event) {
      if (!details.contains(event.relatedTarget)) {
        closeMenu();
      }
    });

    if (submenu) {
      submenu.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        window.clearTimeout(animationTimer);
      });
    }

    /*
     * Desktop par dropdown hover se open hoga.
     * Mobile drawer ka click behavior unchanged rahega.
     */
    if (summary) {
      summary.addEventListener('click', function (event) {
        if (desktopBreakpoint.matches) {
          event.preventDefault();
        }
      });
    }
  });

  desktopBreakpoint.addEventListener('change', function () {
    headerMenus.forEach(function (details) {
      window.clearTimeout(details._animationTimer);

      details.classList.remove('is-open', 'is-closing');
      details.removeAttribute('open');

      const summary = details.querySelector(':scope > summary');

      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    });
  });
});

// Header dropdown on hover with smooth open/close animation